import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EntityActionFactory, EntityCache, HttpUrlGenerator } from "@ngrx/data";
import { Store } from "@ngrx/store";
import { ApiResponse, RestService } from "@recore-solutions/nstar-lib";
import { Observable, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { NstarDataService } from "src/app/nstar-data.service";
import { environment } from "src/environments/environment";
import { ListingHistory } from "./listing-history";

@Injectable({
	providedIn: "root",
})
export class ListingHistoryDataService extends NstarDataService<ListingHistory> {
	constructor(
		protected httpClient: HttpClient,
		protected httpUrlGenerator: HttpUrlGenerator,
		protected restService: RestService,
		protected entityCacheStore: Store<EntityCache>,
		protected entityActionFactory: EntityActionFactory
	) {
		super("ListingHistory", httpClient, httpUrlGenerator, entityCacheStore, entityActionFactory);
	}

	getListingHistoryApiResponse(queryParams?: Record<string, any>): Observable<ListingHistory[]> {
		if (!queryParams.listingSK) {
			return of([]);
		}
		return this.restService
			.get<ApiResponse<ListingHistory, []>>(
				environment.endpoints.listingHistory,
				new HttpParams({ fromObject: queryParams })
			)
			.pipe(
				tap(this.dispatchRelatedRecordActions),
				map(this.mapResponseToRecords),
				catchError(() => of([]))
			);
	}

	getAll(): Observable<ListingHistory[]> {
		return this.getListingHistoryApiResponse();
	}

	getWithQuery(params: Record<string, any>): Observable<ListingHistory[]> {
		return this.getListingHistoryApiResponse(params);
	}
}
